module.exports = __webpack_public_path__ + "static/tr-1-cec9f9d896e10ad37e4535cabd2e5e2d.jpg";